import { t } from "@/i18n-js/instance";

interface TableColumn {
  dataIndex: string;
  key: string;
  title: string;
}

export const TABLE_COLUMNS: TableColumn[] = [
  {
    title: t("settings.paywall_groups.table.name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("settings.paywall_groups.table.paywalls"),
    dataIndex: "paywalls",
    key: "paywalls",
  },
  {
    title: " ",
    dataIndex: "actions",
    key: "actions",
  },
];
